export const CONTROL = "CONTROL";
export const CONTROL_LOADING = "CONTROL_LOADING";
export const CONTROL_ERROR = "CONTROL_ERROR";
export const CONTROL_DATA = "CONTROL_DATA";
export const CONTROL_UPDATE = "CONTROL_UPDATE";
export const CONTROL_CREATE = "CONTROL_CREATE"
